<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage User</p>
    </header>
    <section class="modal-card-body">
    <!--   //////////////////////////////////////////////////////// -->
          <div class="card-content">
            <b-tabs expanded  type="is-boxed">
              <b-tab-item label="Information">
  <div class="columns">
    <div class="column">
      <b-field label="User Code">
        <b-input
            type="text"
            v-model="user.code"
            placeholder="e.g. TRVLM001"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Name">
         <b-input
            type="text"
            v-model="user.name"
            placeholder="e.g. User Taj"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>
  <div class="columns">
    <div class="column">   
       <!--  <p class="content"><b>Selected:</b> {{ selected }}</p> -->
        <b-field label="State">
            <b-autocomplete
            rounded
            icon="search"
            v-model="user.state"
            placeholder="e.g. Gujarat"
            :keep-first="keepFirst"
            :open-on-focus="openOnFocus"
            :data="filteredDataArray"
            @select="option => selected = option">
            </b-autocomplete>
        </b-field>
    </div>
    <div class="column">
<!--  <p class="content"><b>Selected:</b> {{ selected1 }}</p> -->
        <b-field label="City">
            <b-autocomplete
            rounded
            icon="search"
            v-model="user.city"
            placeholder="e.g. Vadodara"
            :keep-first="keepFirst"
            :open-on-focus="openOnFocus"
            :data="filteredDataArraycity"
            @select="option => selected1 = option">
            </b-autocomplete>
        </b-field>
     </div>
  </div>
    <div class="columns">
    <div class="column">
      <b-field label="Area">
        <b-input
            type="text"
           v-model="user.area"
            placeholder="e.g. Bandra"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Pincode">
         <b-input
            type="text"
            v-model="user.pincode"
            placeholder="e.g. 390007"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>

  <div class="columns">
    <div class="column is-6">
<b-field label="Address">
         <b-input
            type="text"
            v-model="user.address"
            placeholder="e.g. C/3 Gaurav Park, Vasna Rd."
            required>
        </b-input>
        
      </b-field>
    </div>
    <div class="column">
        <div class="mt-2">
        <b-switch v-model="user.active">Active</b-switch>        
      </div>
    </div>
  </div>
</b-tab-item>

  <b-tab-item label="Contact">
  <div class="columns">
    <div class="column">
      <b-field label="Owner Name">
        <b-input
            type="text"
            v-model="user.owner"
            placeholder="e.g. Mr. Viral Patel"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="Mobile No.">
         <b-input
            type="text"
            v-model="user.mobile"
            placeholder="e.g. +91 8155950590"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>
   <!--   <div class="columns">
    <div class="column">
      <b-field label="Manager Email">
        <b-input
            type="email"
            v-model="user.m_email"
            placeholder="e.g. viral@usergateway.in"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="User Contact No.">
         <b-input
            type="text"
            v-model="user.no"
            placeholder="e.g. 022 235365"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div> -->
     <div class="columns">
    <div class="column">
      <b-field label="User Email">
        <b-input
            type="email"
            v-model="user.email"
            placeholder="e.g. user@gateway.in"
            required>
        </b-input>
      </b-field>
    </div>
    <div class="column">
      <b-field label="User Website">
         <b-input
            type="text"
            v-model="user.website"
            placeholder="e.g. www.usergateway.in"
            required>
        </b-input>
        
      </b-field>
     </div>
  </div>
  </b-tab-item>

             
             
              <b-tab-item label="Documents">
                <div class="columns">
                  <div class="column">
  <b-field label="Pan Number">
         <b-input
            type="text"
            v-model="user.pan"
            placeholder="e.g. BKLPP5555"
            required>
        </b-input>
      </b-field>
                  </div>

                  <div class="column">
         <b-field label="GST Number">
         <b-input
            type="text"
            v-model="user.gst"
            placeholder="e.g. BKLPP5555"
            required>
        </b-input>
      </b-field>
                  </div>
                </div>
       
                <div class="column has-text-centered">
                 
             <img class="pan-image has-text-centered " :src="user.pan_img || '/static/placeholder_image.png'" alt="Placeholder image"> 
            
             </div>
              </b-tab-item>
              <b-tab-item label="Profile">
                <div class="column has-text-centered">
             <img class="user-image has-text-centered " :src="user.profile_img || '/static/placeholder_image.png'" alt="Placeholder image"> </div>
              </b-tab-item>
            </b-tabs>
          </div>
<!-- /////////////////////////////////////////////// -->
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageUser">Save</button>
    </footer>
  </div>
</template>

<script>
import UserService from './service';
import UploadService from '../../lib/UploadService';
 const data = [
    
       "Andhra Pradesh",
       "Arunachal Pradesh",
       "Bihar",
       "Chandigarh (UT)",
       "Chhattisgarh",
       "Dadra and Nagar Haveli (UT)",
       "Daman and Diu (UT)",
       "Delhi (NCT)",
       "Goa" ,
       "Gujarat" ,
       "Haryana",
       "Himachal Pradesh" ,
       "Jammu and Kashmir",
       "Jharkhand",
       "Karnataka",
       "Kerala",
       "Lakshadweep (UT)",
       "Madhya Pradesh" ,
       "Maharashtra",
       "Manipur",
       "Meghalaya",
       "Mizoram",
       "Nagaland",
       "Odisha",
       "Puducherry (UT)" ,
       "Punjab" ,
       "Rajasthan",
       "Sikkim",
       "Tamil Nadu",
       "Telangana",
       "Tripura",
       "Uttarakhand" ,
       "Uttar Pradesh",
       "West Bengal"
    
   
 ]

const districts = [
             "Anantapur",
             "Chittoor",
             "East Godavari",
             "Guntur",
             "Krishna",
             "Kurnool",
             "Nellore",
             "Prakasam",
             "Srikakulam",
             "Visakhapatnam",
             "Vizianagaram",
             "West Godavari",
             "YSR Kadapa",
             "Tawang",
             "West Kameng",
             "East Kameng",
             "Papum Pare",
             "Kurung Kumey",
             "Kra Daadi",
             "Lower Subansiri",
             "Upper Subansiri",
             "West Siang",
             "East Siang",
             "Siang",
             "Upper Siang",
             "Lower Siang",
             "Lower Dibang Valley",
             "Dibang Valley",
             "Anjaw",
             "Lohit",
             "Namsai",
             "Changlang",
             "Tirap",
             "Longding", "Baksa",
             "Barpeta",
             "Biswanath",
             "Bongaigaon",
             "Cachar",
             "Charaideo",
             "Chirang",
             "Darrang",
             "Dhemaji",
             "Dhubri",
             "Dibrugarh",
             "Goalpara",
             "Golaghat",
             "Hailakandi",
             "Hojai",
             "Jorhat",
             "Kamrup Metropolitan",
             "Kamrup",
             "Karbi Anglong",
             "Karimganj",
             "Kokrajhar",
             "Lakhimpur",
             "Majuli",
             "Morigaon",
             "Nagaon",
             "Nalbari",
             "Dima Hasao",
             "Sivasagar",
             "Sonitpur",
             "South Salmara-Mankachar",
             "Tinsukia",
             "Udalguri",
             "West Karbi Anglong","Araria",
             "Arwal",
             "Aurangabad",
             "Banka",
             "Begusarai",
             "Bhagalpur",
             "Bhojpur",
             "Buxar",
             "Darbhanga",
             "East Champaran (Motihari)",
             "Gaya",
             "Gopalganj",
             "Jamui",
             "Jehanabad",
             "Kaimur (Bhabua)",
             "Katihar",
             "Khagaria",
             "Kishanganj",
             "Lakhisarai",
             "Madhepura",
             "Madhubani",
             "Munger (Monghyr)",
             "Muzaffarpur",
             "Nalanda",
             "Nawada",
             "Patna",
             "Purnia (Purnea)",
             "Rohtas",
             "Saharsa",
             "Samastipur",
             "Saran",
             "Sheikhpura",
             "Sheohar",
             "Sitamarhi",
             "Siwan",
             "Supaul",
             "Vaishali",
             "West Champaran",
             "Chandigarh",
             "Balod",
             "Baloda Bazar",
             "Balrampur",
             "Bastar",
             "Bemetara",
             "Bijapur",
             "Bilaspur",
             "Dantewada (South Bastar)",
             "Dhamtari",
             "Durg",
             "Gariyaband",
             "Janjgir-Champa",
             "Jashpur",
             "Kabirdham (Kawardha)",
             "Kanker (North Bastar)",
             "Kondagaon",
             "Korba",
             "Korea (Koriya)",
             "Mahasamund",
             "Mungeli",
             "Narayanpur",
             "Raigarh",
             "Raipur",
             "Rajnandgaon",
             "Sukma",
             "Surajpur  ",
             "Surguja","Dadra & Nagar Haveli",
             "Daman",
             "Diu",
             "Central Delhi",
             "East Delhi",
             "New Delhi",
             "North Delhi",
             "North East  Delhi",
             "North West  Delhi",
             "Shahdara",
             "South Delhi",
             "South East Delhi",
             "South West  Delhi",
             "West Delhi",
          
       
      
        
             "North Goa",
             "South Goa", "Ahmedabad",
             "Amreli",
             "Anand",
             "Aravalli",
             "Banaskantha (Palanpur)",
             "Bharuch",
             "Bhavnagar",
             "Botad",
             "Chhota Udepur",
             "Dahod",
             "Dangs (Ahwa)",
             "Devbhoomi Dwarka",
             "Gandhinagar",
             "Gir Somnath",
             "Jamnagar",
             "Junagadh",
             "Kachchh",
             "Kheda (Nadiad)",
             "Mahisagar",
             "Mehsana",
             "Morbi",
             "Narmada (Rajpipla)",
             "Navsari",
             "Panchmahal (Godhra)",
             "Patan",
             "Porbandar",
             "Rajkot",
             "Sabarkantha (Himmatnagar)",
             "Surat",
             "Surendranagar",
             "Tapi (Vyara)",
             "Vadodara",
             "Valsad", "Ambala",
             "Bhiwani",
             "Charkhi Dadri",
             "Faridabad",
             "Fatehabad",
             "Gurgaon",
             "Hisar",
             "Jhajjar",
             "Jind",
             "Kaithal",
             "Karnal",
             "Kurukshetra",
             "Mahendragarh",
             "Mewat",
             "Palwal",
             "Panchkula",
             "Panipat",
             "Rewari",
             "Rohtak",
             "Sirsa",
             "Sonipat",
             "Yamunanagar","Bilaspur",
             "Chamba",
             "Hamirpur",
             "Kangra",
             "Kinnaur",
             "Kullu",
             "Lahaul &amp; Spiti",
             "Mandi",
             "Shimla",
             "Sirmaur (Sirmour)",
             "Solan",
             "Una",
             "Anantnag",
             "Bandipore",
             "Baramulla",
             "Budgam",
             "Doda",
             "Ganderbal",
             "Jammu",
             "Kargil",
             "Kathua",
             "Kishtwar",
             "Kulgam",
             "Kupwara",
             "Leh",
             "Poonch",
             "Pulwama",
             "Rajouri",
             "Ramban",
             "Reasi",
             "Samba",
             "Shopian",
             "Srinagar",
             "Udhampur", "Bokaro",
             "Chatra",
             "Deoghar",
             "Dhanbad",
             "Dumka",
             "East Singhbhum",
             "Garhwa",
             "Giridih",
             "Godda",
             "Gumla",
             "Hazaribag",
             "Jamtara",
             "Khunti",
             "Koderma",
             "Latehar",
             "Lohardaga",
             "Pakur",
             "Palamu",
             "Ramgarh",
             "Ranchi",
             "Sahibganj",
             "Seraikela-Kharsawan",
             "Simdega",
             "West Singhbhum",
             "Bagalkot",
             "Ballari (Bellary)",
             "Belagavi (Belgaum)",
             "Bengaluru (Bangalore) Rural",
             "Bengaluru (Bangalore) Urban",
             "Bidar",
             "Chamarajanagar",
             "Chikballapur",
             "Chikkamagaluru (Chikmagalur)",
             "Chitradurga",
             "Dakshina Kannada",
             "Davangere",
             "Dharwad",
             "Gadag",
             "Hassan",
             "Haveri",
             "Kalaburagi (Gulbarga)",
             "Kodagu",
             "Kolar",
             "Koppal",
             "Mandya",
             "Mysuru (Mysore)",
             "Raichur",
             "Ramanagara",
             "Shivamogga (Shimoga)",
             "Tumakuru (Tumkur)",
             "Udupi",
             "Uttara Kannada (Karwar)",
             "Vijayapura (Bijapur)",
             "Yadgir","Alappuzha",
             "Ernakulam",
             "Idukki",
             "Kannur",
             "Kasaragod",
             "Kollam",
             "Kottayam",
             "Kozhikode",
             "Malappuram",
             "Palakkad",
             "Pathanamthitta",
             "Thiruvananthapuram",
             "Thrissur",
             "Wayanad","Agatti",
             "Amini",
             "Androth",
             "Bithra",
             "Chethlath",
             "Kavaratti",
             "Kadmath",
             "Kalpeni",
             "Kilthan",
             "Minicoy",
             "Agar Malwa",
             "Alirajpur",
             "Anuppur",
             "Ashoknagar",
             "Balaghat",
             "Barwani",
             "Betul",
             "Bhind",
             "Bhopal",
             "Burhanpur",
             "Chhatarpur",
             "Chhindwara",
             "Damoh",
             "Datia",
             "Dewas",
             "Dhar",
             "Dindori",
             "Guna",
             "Gwalior",
             "Harda",
             "Hoshangabad",
             "Indore",
             "Jabalpur",
             "Jhabua",
             "Katni",
             "Khandwa",
             "Khargone",
             "Mandla",
             "Mandsaur",
             "Morena",
             "Narsinghpur",
             "Neemuch",
             "Panna",
             "Raisen",
             "Rajgarh",
             "Ratlam",
             "Rewa",
             "Sagar",
             "Satna",
             "Sehore",
             "Seoni",
             "Shahdol",
             "Shajapur",
             "Sheopur",
             "Shivpuri",
             "Sidhi",
             "Singrauli",
             "Tikamgarh",
             "Ujjain",
             "Umaria",
             "Vidisha", "Ahmednagar",
             "Akola",
             "Amravati",
             "Aurangabad",
             "Beed",
             "Bhandara",
             "Buldhana",
             "Chandrapur",
             "Dhule",
             "Gadchiroli",
             "Gondia",
             "Hingoli",
             "Jalgaon",
             "Jalna",
             "Kolhapur",
             "Latur",
             "Mumbai City",
             "Mumbai Suburban",
             "Nagpur",
             "Nanded",
             "Nandurbar",
             "Nashik",
             "Osmanabad",
             "Palghar",
             "Parbhani",
             "Pune",
             "Raigad",
             "Ratnagiri",
             "Sangli",
             "Satara",
             "Sindhudurg",
             "Solapur",
             "Thane",
             "Wardha",
             "Washim",
             "Yavatmal","Bishnupur",
             "Chandel",
             "Churachandpur",
             "Imphal East",
             "Imphal West",
             "Jiribam",
             "Kakching",
             "Kamjong",
             "Kangpokpi",
             "Noney",
             "Pherzawl",
             "Senapati",
             "Tamenglong",
             "Tengnoupal",
             "Thoubal",
             "Ukhrul","East Garo Hills",
             "East Jaintia Hills",
             "East Khasi Hills",
             "North Garo Hills",
             "Ri Bhoi",
             "South Garo Hills",
             "South West Garo Hills ",
             "South West Khasi Hills",
             "West Garo Hills",
             "West Jaintia Hills",
             "West Khasi Hills","Aizawl",
             "Champhai",
             "Kolasib",
             "Lawngtlai",
             "Lunglei",
             "Mamit",
             "Saiha",
             "Serchhip",
             "Dimapur",
             "Kiphire",
             "Kohima",
             "Longleng",
             "Mokokchung",
             "Mon",
             "Peren",
             "Phek",
             "Tuensang",
             "Wokha",
             "Zunheboto",
             "Angul",
             "Balangir",
             "Balasore",
             "Bargarh",
             "Bhadrak",
             "Boudh",
             "Cuttack",
             "Deogarh",
             "Dhenkanal",
             "Gajapati",
             "Ganjam",
             "Jagatsinghapur",
             "Jajpur",
             "Jharsuguda",
             "Kalahandi",
             "Kandhamal",
             "Kendrapara",
             "Kendujhar (Keonjhar)",
             "Khordha",
             "Koraput",
             "Malkangiri",
             "Mayurbhanj",
             "Nabarangpur",
             "Nayagarh",
             "Nuapada",
             "Puri",
             "Rayagada",
             "Sambalpur",
             "Sonepur",
             "Sundargarh",
             "Karaikal",
             "Mahe",
             "Pondicherry",
             "Yanam",
             "Amritsar",
             "Barnala",
             "Bathinda",
             "Faridkot",
             "Fatehgarh Sahib",
             "Fazilka",
             "Ferozepur",
             "Gurdaspur",
             "Hoshiarpur",
             "Jalandhar",
             "Kapurthala",
             "Ludhiana",
             "Mansa",
             "Moga",
             "Muktsar",
             "Nawanshahr (Shahid Bhagat Singh Nagar)",
             "Pathankot",
             "Patiala",
             "Rupnagar",
             "Sahibzada Ajit Singh Nagar (Mohali)",
             "Sangrur",
             "Tarn Taran",
             "Ajmer",
             "Alwar",
             "Banswara",
             "Baran",
             "Barmer",
             "Bharatpur",
             "Bhilwara",
             "Bikaner",
             "Bundi",
             "Chittorgarh",
             "Churu",
             "Dausa",
             "Dholpur",
             "Dungarpur",
             "Hanumangarh",
             "Jaipur",
             "Jaisalmer",
             "Jalore",
             "Jhalawar",
             "Jhunjhunu",
             "Jodhpur",
             "Karauli",
             "Kota",
             "Nagaur",
             "Pali",
             "Pratapgarh",
             "Rajsamand",
             "Sawai Madhopur",
             "Sikar",
             "Sirohi",
             "Sri Ganganagar",
             "Tonk",
             "Udaipur",
             "East Sikkim",
             "North Sikkim",
             "South Sikkim",
             "West Sikkim",
             "Ariyalur",
             "Chennai",
             "Coimbatore",
             "Cuddalore",
             "Dharmapuri",
             "Dindigul",
             "Erode",
             "Kanchipuram",
             "Kanyakumari",
             "Karur",
             "Krishnagiri",
             "Madurai",
             "Nagapattinam",
             "Namakkal",
             "Nilgiris",
             "Perambalur",
             "Pudukkottai",
             "Ramanathapuram",
             "Salem",
             "Sivaganga",
             "Thanjavur",
             "Theni",
             "Thoothukudi (Tuticorin)",
             "Tiruchirappalli",
             "Tirunelveli",
             "Tiruppur",
             "Tiruvallur",
             "Tiruvannamalai",
             "Tiruvarur",
             "Vellore",
             "Viluppuram",
             "Virudhunagar",
             "Adilabad",
             "Bhadradri Kothagudem",
             "Hyderabad",
             "Jagtial",
             "Jangaon",
             "Jayashankar Bhoopalpally",
             "Jogulamba Gadwal",
             "Kamareddy",
             "Karimnagar",
             "Khammam",
             "Komaram Bheem Asifabad",
             "Mahabubabad",
             "Mahabubnagar",
             "Mancherial",
             "Medak",
             "Medchal",
             "Nagarkurnool",
             "Nalgonda",
             "Nirmal",
             "Nizamabad",
             "Peddapalli",
             "Rajanna Sircilla",
             "Rangareddy",
             "Sangareddy",
             "Siddipet",
             "Suryapet",
             "Vikarabad",
             "Wanaparthy",
             "Warangal (Rural)",
             "Warangal (Urban)",
             "Yadadri Bhuvanagiri","Dhalai",
             "Gomati",
             "Khowai",
             "North Tripura",
             "Sepahijala",
             "South Tripura",
             "Unakoti",
             "West Tripura",
             "Almora",
             "Bageshwar",
             "Chamoli",
             "Champawat",
             "Dehradun",
             "Haridwar",
             "Nainital",
             "Pauri Garhwal",
             "Pithoragarh",
             "Rudraprayag",
             "Tehri Garhwal",
             "Udham Singh Nagar",
             "Uttarkashi","Agra",
             "Aligarh",
             "Allahabad",
             "Ambedkar Nagar",
             "Amethi (Chatrapati Sahuji Mahraj Nagar)",
             "Amroha (J.P. Nagar)",
             "Auraiya",
             "Azamgarh",
             "Baghpat",
             "Bahraich",
             "Ballia",
             "Balrampur",
             "Banda",
             "Barabanki",
             "Bareilly",
             "Basti",
             "Bhadohi",
             "Bijnor",
             "Budaun",
             "Bulandshahr",
             "Chandauli",
             "Chitrakoot",
             "Deoria",
             "Etah",
             "Etawah",
             "Faizabad",
             "Farrukhabad",
             "Fatehpur",
             "Firozabad",
             "Gautam Buddha Nagar",
             "Ghaziabad",
             "Ghazipur",
             "Gonda",
             "Gorakhpur",
             "Hamirpur",
             "Hapur (Panchsheel Nagar)",
             "Hardoi",
             "Hathras",
             "Jalaun",
             "Jaunpur",
             "Jhansi",
             "Kannauj",
             "Kanpur Dehat",
             "Kanpur Nagar",
             "Kanshiram Nagar (Kasganj)",
             "Kaushambi",
             "Kushinagar (Padrauna)",
             "Lakhimpur - Kheri",
             "Lalitpur",
             "Lucknow",
             "Maharajganj",
             "Mahoba",
             "Mainpuri",
             "Mathura",
             "Mau",
             "Meerut",
             "Mirzapur",
             "Moradabad",
             "Muzaffarnagar",
             "Pilibhit",
             "Pratapgarh",
             "RaeBareli",
             "Rampur",
             "Saharanpur",
             "Sambhal (Bhim Nagar)",
             "Sant Kabir Nagar",
             "Shahjahanpur",
             "Shamali (Prabuddh Nagar)",
             "Shravasti",
             "Siddharth Nagar",
             "Sitapur",
             "Sonbhadra",
             "Sultanpur",
             "Unnao",
             "Varanasi",
             "Alipurduar",
             "Bankura",
             "Birbhum",
             "Burdwan (Bardhaman)",
             "Cooch Behar",
             "Dakshin Dinajpur (South Dinajpur)",
             "Darjeeling",
             "Hooghly",
             "Howrah",
             "Jalpaiguri",
             "Kalimpong",
             "Kolkata",
             "Malda",
             "Murshidabad",
             "Nadia",
             "North 24 Parganas",
             "Paschim Medinipur (West Medinipur)",
             "Purba Medinipur (East Medinipur)",
             "Purulia",
             "South 24 Parganas",
             "Uttar Dinajpur (North Dinajpur)"
          
]

export default {
  
  name: 'addUser',
  props: ['propUser'],

  created() {
  
    if (this.propUser.docId) {
      this.user = { ...this.propUser };}
  },
  
  data() {
    return {
      isLoading: false,
      user: {
        state : '',
        city : ''
      },
      priceList: {},
      data,
      districts,
      keepFirst: false,
      openOnFocus: false,
      test: '',
      files: null,
      pan_img : null,
      profile_img:null,
      file: null,
      city :'',
      state: '',
      selected: null,
      selected1: null
    };
  },

  methods: {
    uploadImage() {
      UploadService(this.files[0], 'users', user.docId)
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    },
   addItemToPriceList() {
      if (!this.user.rooms) {
        this.user.rooms = [];
      }
      
      this.user.rooms.push({
        room_name: this.priceList.room_name,
        adult: this.priceList.adult,
        CWB: this.priceList.CWB,
        CWOB: this.priceList.CWOB,
        Xadult: this.priceList.Xadult
      });

       this.priceList = {};
      
    },
    manageUser() {
      this.isLoading = true;
      
        UserService.manageUser(this.user).then(
        newUser => {
          this.isLoading = false;
          const isNewUser = !this.user.docId;
          const userObj = { ...this.user };

          if (isNewUser) {
            userObj.docId = newUser.id;
          }

        /*   
        let email = user.email;
        let password = user.code;
        firebase.auth().createUserWithEmailAndPassword(email, password)
          .then(response => { 
            this.$toast.open('User Created successfull');
          })
          .catch(err => {
            console.log(err);
          }); */

          this.$bus.$emit('QURY_UPDATE', userObj, isNewUser);
          this.$emit('close');
          this.$toast.open('User Updated successfull');
          console.log(test);
          console.log(test1)
        }
      );
    },
    removeItemFromPriceList(index) {
      this.user.rooms.splice(index, 1);
      this.priceList = {};
    },
   },
   computed: {
           filteredDataArray() {
         
                return this.data.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.user.state.toLowerCase()) >= 0
                })
            },
            filteredDataArraycity() {
         
                return this.districts.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.user.city.toLowerCase()) >= 0
                })
            }

            

        }
};
</script>
<style>
.pan-image{
    height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/AddUser.vue